<template>
  <header class="home__header grid grid-2">
    <h1 class="heading--h1">
      <span class="yellow">Hey There !</span> <br />
      <span>welcome to</span> <span class="pink">NAC_Code</span>
    </h1>

    <p class="paragraph">
      we provide
      <span class="highlight">High quality, creative and unique websites</span>
      for all purposes.

      <br />
      <br /><span class="highlight">VNOUN Website</span> is the best e-commerce
      website in codecanyon.
    </p>

    <a
      class="btn btn--gredient btn--huge"
      href="https://vnoun.onrender.com/home"
      target="_blank"
    >
      view demo
    </a>
    <div class="home__header--right">
      <img
        src="/images/background-js-rounded.svg"
        alt="image"
        class="home__header__thumb-img home__header__thumb-img--js"
      />
      <img
        src="/images/background-html.svg"
        alt="image"
        class="home__header__thumb-img home__header__thumb-img--html"
      />
      <img
        src="/images/setting.svg"
        alt="image"
        class="home__header__thumb-img home__header__thumb-img--setting"
      />
      <img
        src="/images/background-tag.svg"
        alt="image"
        class="home__header__thumb-img home__header__thumb-img--tag"
      />

      <img
        src="/images/circle-purple.svg"
        alt="image"
        class="home__header__thumb-img home__header__thumb-img--circle"
      />

      <img src="/images/header-man.svg" alt="image" class="home__header__img" />
    </div>
  </header>
</template>
